/* Ensure every storefront search field submits reliably with the Enter key. */
(() => {
  if (window.DSSearchEnterFixInstalled) return;
  window.DSSearchEnterFixInstalled = true;

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || event.isComposing) return;

    const input = event.target.closest?.('form[role="search"] input[type="search"][name="q"]');
    if (!input || !input.value.trim()) return;

    const form = input.form;
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const destination = new URL(form.action || '/search', window.location.origin);
    destination.searchParams.set('q', input.value.trim());

    form.querySelectorAll('input[type="hidden"][name]').forEach((field) => {
      destination.searchParams.set(field.name, field.value);
    });

    window.location.assign(destination.href);
  }, true);
})();
